/**
 * Partner admin UI + deep links.
 * Set REACT_APP_PARTNER_API=false at build time to hide Partners / Partner Audit
 * (matches backend PARTNER_API=false).
 * Unset or true → enabled.
 */
export const isPartnerApiEnabled = () => {
  const raw = String(process.env.REACT_APP_PARTNER_API ?? "")
    .trim()
    .toLowerCase();
  if (raw === "false" || raw === "0" || raw === "no" || raw === "off") {
    return false;
  }
  return true;
};
